class RetrySignedKeyListError extends Error {
    public trace = false;
}

export default RetrySignedKeyListError;
